import React from 'react';
import { Card } from '../ui/card';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const ContactInfoCard = ({ phoneNumber, email }) => (
  <Card className="p-6 bg-white border-2 border-blue-200">
    <h3 className="text-2xl font-bold text-slate-900 mb-6">Floria Maler Sanierung</h3>
    
    <div className="space-y-4">
      <div className="flex items-start gap-4">
        <MapPin className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-slate-900">Hauptsitz</div>
          <div className="text-slate-600">
            Fahrstrasse 7<br />
            5314 Kleindöttingen<br />
            Schweiz
          </div>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <Phone className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-slate-900">Telefon</div>
          <a href={`tel:${phoneNumber}`} className="text-blue-600 hover:underline">
            {phoneNumber}
          </a>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <Mail className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-slate-900">E-Mail</div>
          <a href={`mailto:${email}`} className="text-blue-600 hover:underline">
            {email}
          </a>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <Clock className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-slate-900">Öffnungszeiten</div>
          <div className="text-slate-600">
            Montag - Freitag: 07:00 - 18:00<br />
            Samstag: 08:00 - 16:00<br />
            Sonntag: Notdienst verfügbar
          </div>
        </div>
      </div>
    </div>
  </Card>
);

export default ContactInfoCard;
